import React from "react";
import styled, { keyframes } from "styled-components";

const HomePageSvg = () => {
  return (
    <Cat>
      <svg
        width="888"
        height="773"
        viewBox="0 0 888 773"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="888" height="773" fill="#fff" />
        <g id="homesvg 1" clipPath="url(#clip0)">
          <path
            id="Vector"
            d="M887.772 763.25L252.263 772.831L0 728.121H393.817L887.772 763.25Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_2"
            d="M731.822 203.32C787.968 203.32 833.482 157.806 833.482 101.66C833.482 45.5148 787.968 0 731.822 0C675.677 0 630.162 45.5148 630.162 101.66C630.162 157.806 675.677 203.32 731.822 203.32Z"
            fill="#FF6584"
          />
          <path
            id="Vector_3"
            d="M179.84 733.435C179.84 733.435 181.327 702.276 211.812 705.898Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_4"
            d="M171.227 703.784C179.653 703.784 186.484 696.953 186.484 688.526C186.484 680.1 179.653 673.269 171.227 673.269C162.801 673.269 155.97 680.1 155.97 688.526C155.97 696.953 162.801 703.784 171.227 703.784Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_5"
            d="M173.051 714.218H168.744V744.365H173.051V714.218Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_6"
            d="M682.287 738.757C682.287 738.757 683.774 707.599 714.258 711.22Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_7"
            d="M673.673 709.106C682.1 709.106 688.93 702.275 688.93 693.849C688.93 685.423 682.1 678.592 673.673 678.592C665.247 678.592 658.416 685.423 658.416 693.849C658.416 702.275 665.247 709.106 673.673 709.106Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_8"
            d="M675.497 719.541H671.191V749.688H675.497V719.541Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_9"
            d="M755.738 744.08C755.738 744.08 757.225 712.921 787.709 716.543Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_10"
            d="M747.124 714.429C755.55 714.429 762.381 707.598 762.381 699.171C762.381 690.745 755.55 683.914 747.124 683.914C738.698 683.914 731.867 690.745 731.867 699.171C731.867 707.598 738.698 714.429 747.124 714.429Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_11"
            d="M748.948 724.863H744.642V755.01H748.948V724.863Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_12"
            d="M300.129 718.532C300.129 718.532 301.616 687.373 332.101 690.995Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_13"
            d="M291.516 688.88C299.942 688.88 306.773 682.05 306.773 673.623C306.773 665.197 299.942 658.366 291.516 658.366C283.09 658.366 276.259 665.197 276.259 673.623C276.259 682.05 283.09 688.88 291.516 688.88Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_14"
            d="M293.34 699.315H289.033V729.462H293.34V699.315Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_15"
            d="M73.3898 723.854C73.3898 723.854 74.8768 692.696 105.361 696.317Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_16"
            d="M64.7764 694.203C73.2027 694.203 80.0335 687.372 80.0335 678.946C80.0335 670.52 73.2027 663.689 64.7764 663.689C56.3501 663.689 49.5193 670.52 49.5193 678.946C49.5193 687.372 56.3501 694.203 64.7764 694.203Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_17"
            d="M66.6005 704.638H62.2938V734.785H66.6005V704.638Z"
            fill="#3F3D56"
          />
          <g id="kedicik">
            <path
              id="Vector_18"
              d="M442.277 669.71C534.082 669.71 608.505 595.287 608.505 503.482C608.505 411.677 534.082 337.254 442.277 337.254C350.472 337.254 276.049 411.677 276.049 503.482C276.049 595.287 350.472 669.71 442.277 669.71Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_19"
              d="M337.626 516.826C341.754 511.883 346.918 507.908 352.751 505.179C358.584 502.451 364.946 501.037 371.385 501.037C377.825 501.037 384.187 502.451 390.02 505.179C395.853 507.908 401.017 511.883 405.145 516.826C412.209 510.082 417.092 501.377 419.163 491.833C421.235 482.289 420.401 472.343 416.769 463.278C413.136 454.212 406.872 446.442 398.783 440.969C390.694 435.496 381.152 432.571 371.385 432.571C361.619 432.571 352.077 435.496 343.988 440.969C335.899 446.442 329.635 454.212 326.002 463.278C322.37 472.343 321.536 482.289 323.607 491.833C325.679 501.377 330.562 510.082 337.626 516.826V516.826Z"
              fill="white"
            />
            <path
              id="Vector_20"
              d="M469.631 516.826C473.759 511.883 478.922 507.908 484.756 505.179C490.589 502.451 496.95 501.037 503.39 501.037C509.83 501.037 516.191 502.451 522.025 505.179C527.858 507.908 533.021 511.883 537.15 516.826C544.214 510.082 549.096 501.377 551.168 491.833C553.24 482.289 552.406 472.343 548.773 463.278C545.141 454.212 538.877 446.442 530.788 440.969C522.699 435.496 513.157 432.571 503.39 432.571C493.624 432.571 484.081 435.496 475.993 440.969C467.904 446.442 461.64 454.212 458.007 463.278C454.375 472.343 453.541 482.289 455.612 491.833C457.684 501.377 462.567 510.082 469.631 516.826Z"
              fill="white"
            />
            <path
              id="Vector_21"
              d="M354.707 481.632C363.996 481.632 371.525 474.102 371.525 464.814C371.525 455.526 363.996 447.996 354.707 447.996C345.419 447.996 337.889 455.526 337.889 464.814C337.889 474.102 345.419 481.632 354.707 481.632Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_22"
              d="M486.707 481.632C495.996 481.632 503.525 474.102 503.525 464.814C503.525 455.526 495.996 447.996 486.707 447.996C477.419 447.996 469.889 455.526 469.889 464.814C469.889 474.102 477.419 481.632 486.707 481.632Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_23"
              d="M322.495 564.595C333.295 564.595 342.051 555.84 342.051 545.039C342.051 534.238 333.295 525.483 322.495 525.483C311.694 525.483 302.939 534.238 302.939 545.039C302.939 555.84 311.694 564.595 322.495 564.595Z"
              fill="#FF6584"
            />
            <path
              id="Vector_24"
              d="M547.392 564.595C558.192 564.595 566.948 555.84 566.948 545.039C566.948 534.238 558.192 525.483 547.392 525.483C536.591 525.483 527.836 534.238 527.836 545.039C527.836 555.84 536.591 564.595 547.392 564.595Z"
              fill="#FF6584"
            />
            <path
              id="Vector_25"
              d="M434.943 505.926L420.276 569.484L444.721 545.039L434.943 505.926Z"
              fill="#FF6584"
            />
            <path
              id="Vector_26"
              d="M510.307 750.38L493.655 736.404L494.043 750.38H488.871L488.458 735.602L465.975 750.38H456.563L488.29 729.526L487.061 685.737L486.143 652.666L491.302 652.524L492.233 685.737L493.461 729.487L518.348 750.38H510.307Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_27"
              d="M432.076 750.38L415.424 736.404L415.812 750.38H410.654L410.24 735.602L387.757 750.38H378.345L410.059 729.526L408.831 685.737L407.913 652.666L413.084 652.524L414.015 685.737L415.23 729.487L440.118 750.38H432.076Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_28"
              d="M444.721 325.031C440.16 325.031 436.137 328.574 433.447 334.016C431.075 325.833 426.094 320.142 420.276 320.142C419.881 320.181 419.488 320.247 419.102 320.339C416.866 311.602 411.668 305.475 405.609 305.475C397.508 305.475 390.942 316.419 390.942 329.92C390.942 343.421 397.508 354.365 405.609 354.365C406.004 354.326 406.397 354.26 406.783 354.168C409.019 362.905 414.217 369.033 420.276 369.033C424.837 369.033 428.861 365.49 431.551 360.048C433.922 368.231 438.904 373.922 444.721 373.922C452.822 373.922 459.389 362.977 459.389 349.476C459.389 335.976 452.822 325.031 444.721 325.031Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_29"
              d="M286.25 566.475C279.83 566.475 273.472 565.21 267.541 562.754C261.609 560.297 256.219 556.695 251.679 552.155C247.14 547.615 243.538 542.226 241.081 536.294C238.624 530.362 237.36 524.005 237.36 517.584V493.139C237.36 480.172 242.511 467.737 251.679 458.568C260.848 449.399 273.284 444.248 286.25 444.248V444.248V566.475Z"
              fill="#6C63FF"
            />
            <path
              id="Vector_30"
              d="M598.303 444.248C604.724 444.248 611.081 445.513 617.013 447.97C622.945 450.427 628.334 454.028 632.874 458.568C637.414 463.108 641.016 468.498 643.473 474.429C645.93 480.361 647.194 486.719 647.194 493.139V517.584C647.194 524.005 645.93 530.362 643.473 536.294C641.016 542.226 637.414 547.615 632.874 552.155C628.334 556.695 622.945 560.296 617.013 562.753C611.081 565.21 604.724 566.475 598.304 566.475V566.475V444.248H598.303Z"
              fill="#6C63FF"
            />
            <path
              id="Vector_31"
              d="M623.923 496.98H616.166C616.166 398.603 536.13 318.567 437.752 318.567C339.375 318.567 259.338 398.603 259.338 496.98H251.581C251.581 394.325 335.097 310.81 437.752 310.81C540.408 310.81 623.923 394.326 623.923 496.98Z"
              fill="#6C63FF"
            />
          </g>
          <path
            id="note6"
            d="M255.358 457.351L255.359 457.348L251.715 455.83L236.338 449.33L230.827 447L230.404 448.068L223 466.762L243.837 475.581L243.946 475.68L242.542 478.991C242.35 479.294 242.186 479.614 242.052 479.946C241.069 482.43 242.926 484.9 244.682 485.596C246.439 486.291 248.66 484.842 249.643 482.359C250.614 479.909 249.665 476.797 247.954 476.045L247.955 476.042L244.311 474.524L231.844 469.678L238.968 451.693L237.912 451.274L230.786 469.266L229.245 468.667L236.398 450.605L236.587 450.685L251.241 456.887L251.35 456.986L249.946 460.297C249.754 460.6 249.59 460.92 249.456 461.252C248.472 463.736 250.33 466.206 252.086 466.902C253.842 467.597 256.064 466.148 257.047 463.664C258.017 461.215 257.069 458.103 255.358 457.351Z"
            fill="#3F3D56"
          />
          <path
            id="note5"
            d="M257.269 503.317C249.705 498.992 251.219 489.502 251.219 489.502C251.028 483.336 245.935 484.209 245.935 484.209L244.081 484.632C243.22 484.232 242.271 484.057 241.324 484.122L238.504 484.597C244.925 486.106 244.398 491.477 244.398 491.477L245.297 497.758L228.472 490.971L230.404 486.416C230.671 485.995 230.898 485.551 231.084 485.088C232.45 481.639 229.87 478.208 227.431 477.242C224.992 476.276 221.907 478.289 220.541 481.738C219.193 485.141 220.51 489.463 222.887 490.507L222.885 490.512L227.947 492.619L227.984 492.5L257.269 503.317ZM248.725 492.281L249.264 498.293C247.359 495.619 246.464 492.357 246.738 489.086C246.694 487.922 246.301 486.799 245.611 485.861C246.672 486.54 247.524 487.499 248.073 488.632C248.622 489.765 248.848 491.028 248.725 492.281V492.281Z"
            fill="#3F3D56"
          />
          <path
            id="note4"
            d="M231.659 507.822L231.661 507.818L226.599 505.71L205.445 497.486L210.784 492.736C211.828 491.344 213.371 490.409 215.089 490.128C216.806 489.846 218.566 490.24 220.001 491.226L218.344 488.764C218.344 488.764 215.229 484.64 210.869 489.003C210.869 489.003 205.474 496.956 197 494.929L225.94 507.178L226.092 507.316L224.142 511.914C223.875 512.334 223.647 512.779 223.462 513.241C222.095 516.69 224.676 520.121 227.115 521.087C229.554 522.054 232.639 520.04 234.005 516.591C235.352 513.189 234.036 508.866 231.659 507.822Z"
            fill="#3F3D56"
          />
          <path
            id="note3"
            d="M222.092 488.834L220.142 493.432C219.875 493.853 219.647 494.297 219.462 494.759C218.095 498.209 220.676 501.64 223.115 502.606C225.554 503.572 228.639 501.559 230.005 498.109C231.353 494.707 230.036 490.385 227.659 489.34L227.661 489.336L222.599 487.228L205.284 480.497L215.177 455.518L213.711 454.937L203.814 479.926L201.673 479.094L211.609 454.007L211.87 454.118L232.223 462.732L232.375 462.87L230.425 467.468C230.158 467.889 229.93 468.333 229.745 468.795C228.379 472.245 230.959 475.676 233.398 476.642C235.837 477.608 238.922 475.595 240.288 472.145C241.636 468.743 240.319 464.421 237.942 463.376L237.944 463.372L232.882 461.264L212.198 452.52L212.197 452.52L211.526 452.236L203.871 449L193 476.447L221.94 488.696L222.092 488.834Z"
            fill="#3F3D56"
          />
          <path
            id="note2"
            d="M275.663 466.844L275.666 466.837L266.953 463.208L230.537 449.052L239.728 440.875C239.728 440.875 245.842 432.392 255.594 438.276L252.742 434.036C252.742 434.036 247.38 426.938 239.874 434.448C239.874 434.448 230.587 448.139 216 444.649L265.819 465.735L266.08 465.972L262.723 473.888C262.264 474.612 261.872 475.377 261.552 476.172C259.2 482.11 263.642 488.017 267.841 489.68C272.04 491.343 277.35 487.877 279.702 481.939C282.021 476.082 279.754 468.642 275.663 466.844Z"
            fill="#3F3D56"
          />
          <path
            id="note1"
            d="M269.107 565.921C251.022 555.581 254.641 532.891 254.641 532.891C254.186 518.15 242.007 520.237 242.007 520.237L237.575 521.248C235.516 520.292 233.249 519.873 230.984 520.029L224.241 521.164C239.594 524.771 238.333 537.614 238.333 537.614L240.484 552.632L200.255 536.403L204.874 525.512C205.512 524.506 206.057 523.444 206.501 522.339C209.767 514.092 203.598 505.888 197.766 503.579C191.934 501.269 184.559 506.082 181.293 514.329C178.071 522.464 181.219 532.798 186.902 535.295L186.898 535.305L198.999 540.345L199.089 540.06L269.107 565.921ZM248.678 539.535L249.972 553.959C242.377 543.876 243.929 531.896 243.929 531.896C243.822 529.114 242.884 526.428 241.235 524.185C249.96 529.407 248.678 539.535 248.678 539.535H248.678Z"
            fill="#3F3D56"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="887.772" height="772.831" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Cat>
  );
};

export default HomePageSvg;

const notes = keyframes`
  0% {
    transform: scale(1) translate(0, 0);
    opacity: 0;
  }
  70% {
    opacity: 1;
    transform: scale(1.5) translate(-0%, -60%);
  }
  100% {
    transform: scale(1) translate(100%, -100%);
    opacity: 0;
  }
`;

const pop = keyframes`
      0% {
         transform : translateY(0)
      }

      50% {
        transform : translateY(-20px)
      }
     
`;

const Cat = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  #note1,
  #note2,
  #note3,
  #note4,
  #note5,
  #note6 {
    opacity: 0;
  }

  svg {
    height: 500px;
    width: 500px;
  }

  #kedicik {
    animation: ${pop} 1s ease-in infinite;
  }

  #note1 {
    animation: 3s ${notes} infinite linear;
    transform-origin: center;
    animation-delay: 0.5s;
    //transform-box: fill-box;
  }

  #note2,
  #note3 {
    animation: 3s ${notes} infinite linear;
    transform-origin: center;
    animation-delay: 0.9s;
    //transform-box: fill-box;
  }

  #note4,
  #note5,
  #note6 {
    animation: 3s ${notes} infinite linear;
    transform-origin: center;
    animation-delay: 1.4s;
    //transform-box: fill-box;
  }
`;
